import React from "react";
import { Link } from "react-router-dom";

import Page from "../../../../components/Page";
import OrderableQuestionnaires from "../../components/OrderableQuestionnaires";
import { translations } from "../../../../config";

/**
 * Komponente um statische Inhalte auszugeben
 */
class ExecutableSurveys extends React.Component
{
	render()
	{
		const { orderableQuestionnaires } = { ...this.props };
		
		return <Page title={"Richtlinienrecherche"} pageUrl={"/richtlinienrecherche"}>
			<div className={"col s12"}>
				<h3>Auf dem Weg zur CE-Konformität</h3>
				<p>Jedes Produkt, das auf dem europäischen Binnenmarkt in Verkehr gebracht oder in Betrieb genommen werden soll, muss die „Wesentlichen Anforderungen“ der
					EU-Binnenmarktrichtlinien bzw. EU-Verordnungen erfüllen, welche für das Produkt zutreffend sind. Im CE-Prozessworkflow zur Produkteinführung wird dieser
					Meilenstein als „Richtlinienrecherche“ bezeichnet.</p>
				<p>Um gewährleisten zu können, dass ein Produkt CE-konform hergestellt wurde, muss der Hersteller im ersten Schritt des CE-Prozesses zur Produkteinführung folgende
					grundlegenden Sachverhalte klären:</p>
				<ol>
					<li>Welche der zahllosen EU-Binnenmarktrichtlinien bzw. EU-Verordnungen sind für sein Produkt maßgeblich?</li>
					<li>Welche Konformitätsbewertungsverfahren müssen im Einzelnen durchgeführt werden?</li>
				</ol>
				<p>Imera unterstützt Sie mit Hilfe von Einstufungsassistenten effizient und rechtskonform bei der Durchführung der gesetzlich vorgeschriebenen
					Richtlinienrecherche.</p>
				<p>Dabei führen Sie unsere Einstufungsassistenten zielführend Schritt für Schritt durch den komplexen Inhalt der Richtlinien. Ein smarter Workflow sorgt dafür, dass
					Sie Ihren gesetzlichen Vorgaben ohne Umwege und damit zeitsparend nachkommen können. Sie müssen einfach nur die Ihnen gestellten Fragen mit „JA“ oder „NEIN“
					beantworten, den Rest erledigt der Assistent für Sie. Sollte sich Ihnen die Bedeutung einer Frage nicht vollständig erschließen, so bieten die Assistenten eine
					direkte Hilfestellung an oder verweisen auf offizielle EU-Quellen, die den Sachverhalt umfangreich erklären.</p>
				<p>Am Ende jeder Recherche wird Ihnen das Ergebnis mitgeteilt. Hierzu gehört unter anderem:</p>
				<ul>
					<li>Ob die Richtlinie für Ihr Produkt maßgeblich und damit anzuwenden ist.</li>
					<li>In welche Erzeugnisgruppe Ihr Produkt gemäß der Richtlinie einzustufen ist.</li>
					<li>Welches Konformitätsbewertungsverfahren Sie durchführen müssen.</li>
				</ul>
				<p>Die gestellten Fragen inkl. Antworten und Kommentare und das Ergebnis der Recherche werden in Form eines PDF-Dokumentes ausgegeben. Damit werden Sie in die Lage
					versetzt, dass Ergebnis zu archivieren. Des Weiteren können Sie die Recherche für die interne Dokumentation ausdrucken und kommen somit Ihren gesetzlich
					vorgeschriebenen Herstellerpflichten nach.</p>
				<p>Im Sinne der Digitalen Transformation - Industrie 4.0 - haben wir die jahrzehntelange Erfahrung zweier Top-Experten in diesem digitalen Service zusammengebracht.
					Das fundierte Fachwissen des Ingenieurbüros Schuster auf dem Gebiet der Maschinen- und Anlagensicherheit und das IT-Knowhow der Firma Test GmbH bilden die
					nachweisbare Kompetenz, auf die Sie zählen können.</p>
				
				{orderableQuestionnaires.length > 0 && <OrderableQuestionnaires questionnaires={orderableQuestionnaires} basicPriceInfo/>}
				
				<div className={"col s12 spacer"}/>
				
				<Link to={translations.de_DE.routes.registration}>
					<h3 className={"col m8 unset-padding margin-bottom"}>Eröffnen Sie jetzt Ihr Imera Kundenkonto.</h3>
					<div className={"col m4 tRight unset-padding"}>
						<div className={"btn"}>Los geht´s!</div>
					</div>
				</Link>
				
				<div className={"col s12 spacer"}/>
			</div>
		</Page>;
		
	} // function render()
	
} // class

export default ExecutableSurveys;